<section class="h5 d-flex flex-column flex-md-column flex-lg-row flex-xl-row gap-2">
    <strong class="mb-2">Step 2:</strong> 
    <span class="fw-normal">Availability</span>
</section>
<p class="text-muted mb-4"><strong>Good news!</strong> We’re in your neighborhood! Pick the day that works best, and provide any instructions that will help ensure we get your food to the right place.</p>
<form [formGroup]="svc.availabilityForm" class="row g-3">
    <div class="col-md-4">
        <label class="form-label small fw-medium">DELIVERY DAY*</label>
        <select class="form-select" formControlName="day">
            <option [ngValue]="null">Select a day</option>
            <option *ngFor="let d of days()" [ngValue]="d.id">{{ d.name }}</option>
        </select>
    </div>
    <div class="col-md-4">
        <label class="form-label small fw-medium">DELIVERY WINDOW*</label>
        <select class="form-select" formControlName="window">
            <option [ngValue]="null">Select a window</option>
            <option *ngFor="let w of windows()" [ngValue]="w.id">{{ w.name }}</option>
        </select>
    </div>
    <div class="col-12">
        <label class="form-label small fw-medium">ADDITIONAL NOTES FOR DRIVER</label>
        <textarea class="form-control" rows="3" formControlName="notes"
            placeholder="Anything else you'd like your driver to know? (Gate code, secret handshake, where to leave the goods, etc.?)"></textarea>
    </div>

    <!-- Botón para continuar -->
    <div class="col-12 d-flex justify-content-center mt-4">
        <button type="button" 
                class="btn btn-primary px-4" 
                [disabled]="!svc.canProceed('availability')"
                (click)="onNext()">
            Next <span class="ms-1">→</span>
        </button>
    </div>
</form>